import * as React from 'react';
import { cn } from '../../lib/utils';

const VARIANTS = {
  default: 'bg-muted text-text-muted border-border',
  primary: 'bg-primary-soft text-primary border-primary/30',
  accent: 'bg-accent-soft text-warning border-accent/30',
  success: 'bg-success-soft text-success border-success/30',
  destructive: 'bg-destructive-soft text-destructive border-destructive/30',
  outline: 'bg-transparent text-text-muted border-border',
};

const Badge = React.forwardRef(({ className, variant = 'default', icon, children, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'inline-flex items-center gap-sm rounded-pill border px-md py-xs',
      'text-badge font-medium whitespace-nowrap',
      VARIANTS[variant],
      className
    )}
    {...props}
  >
    {icon && <i className={cn('bi', icon)} aria-hidden="true" />}
    {children}
  </span>
));
Badge.displayName = 'Badge';

export { Badge };
